import React, { FC } from 'react';
import cn from 'classnames';
import Exterior from './exterior';
import Interior from './interior';

interface Props {
  className?: string;
  activeView: string;
  modelCode?: number;
  doors?: number;
  train?: string;
  year?: string;
  trim?: string;
}

const View360: FC<Props> = ({
  className,
  activeView,
  modelCode,
  doors,
  train,
  year,
  trim,
}: Props) => {
  const viewIsActive =
    (className &&
      className.indexOf('image-gallery-container__content-view360--active') >
        -1) ??
    false;
  return (
    <div
      data-cy="image-gallery-container__content-view360"
      className={cn(className)}
    >
      <>
        {viewIsActive && (
          <>
            {activeView === 'Exterior' || activeView === 'Exterior View' ? (
              <Exterior
                modelCode={modelCode}
                doors={doors}
                train={train}
                year={year}
                trim={trim}
              ></Exterior>
            ) : (
              <Interior
                modelCode={modelCode}
                doors={doors}
                train={train}
                year={year}
                trim={trim}
              ></Interior>
            )}
          </>
        )}
      </>
    </div>
  );
};

export default View360;
